import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SFIcon } from 'components/core/SFIcon';
import { Button } from 'components/core/Button';

import './ModalClose.scss';

export default function ModalClose({ onClick, className }) {
	return (
		<Button
			onClick={onClick}
			className={classnames('modal-close-button', className)}
			primary={false}
		>
			<SFIcon icon="close" />
		</Button>
	);
}

ModalClose.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func
};
